module.exports = __webpack_public_path__ + "static/Sunnyvale-a12bce06c89736820132637f2a516b39.jpg";